import { Container } from "inversify";
import "reflect-metadata";
import Constants, { ConstantsName } from "./data/settings/constants/Constants";
import ConstantsFake from "./data/settings/constants/ConstantsFake";
import HostApi, { HostApiName } from "./data/settings/HostApi";
import ConstantsDev from "./data/settings/constants/ConstantsDev";
import ConstantsImpl from "./data/settings/constants/ConstantsImpl";
import LocalizationRepository, { LocalizationRepositoryName } from "./domain/repositories/LocalizationRepository";
import LocalizationRepositoryFake from "./data/repositories/localization/LocalizationRepositoryFake";
import LocalizationRepositoryDev from "./data/repositories/localization/LocalizationRepositoryDev";
import LocalizationProvider, { LocalizationProviderName } from "./domain/providers/localization/LocalizationProvider";
import LocalizationProviderImpl from "./presentation/providers/localization/LocalizationProviderImpl";
import UserProvider, { UserProviderName } from "./domain/providers/user/UserProvider";
import UserProviderImpl from "./presentation/providers/user/UserProviderImpl";
import ModalsProvider, { ModalsProviderName } from "./domain/providers/modal/ModalsProvider";
import ModalsProviderImpl from "./presentation/providers/modal/ModalsProviderImpl";
import LoadUseCase, { LoadUseCaseName } from "./domain/use_cases/default/LoadUseCase";
import GetAvailableLanguagesUseCase, { GetAvailableLanguagesUseCaseName } from "./domain/use_cases/localization/GetAvailableLanguagesUseCase";
import GetCurrentLanguageUseCase, { GetCurrentLanguageUseCaseName } from "./domain/use_cases/localization/GetCurrentLanguageUseCase";
import SetCurrentLanguageUseCase, { SetCurrentLanguageUseCaseName } from "./domain/use_cases/localization/SetCurrentLanguageUseCase";
import LoginWithEmailAndPasswordUseCase, { LoginWithEmailAndPasswordUseCaseName } from "./domain/use_cases/auth/LoginWithEmailAndPasswordUseCase";
import AuthRepository, { AuthRepositoryName } from "./domain/repositories/AuthRepository";
import LogoutUseCase, { LogoutUseCaseName } from "./domain/use_cases/auth/LogoutUseCase";
import AuthRepositoryFake from "./data/repositories/auth/AuthRepositoryFake";
import AuthRepositoryDev from "./data/repositories/auth/AuthRepositoryDev";
import AuthRepositoryImpl from "./data/repositories/auth/AuthRepositoryImpl";
import GetCurrentUserUseCase, { GetCurrentUserUseCaseName } from "./domain/use_cases/auth/GetCurrentUserUseCase";
import UserRepository, { UserRepositoryName } from "./domain/repositories/UserRepository";
import SearchUsersUseCase, { SearchUsersUseCaseName } from "./domain/use_cases/user/SearchUsersUseCase";
import GetUserByIdUseCase, { GetUserByIdUseCaseName } from "./domain/use_cases/user/GetUserByIdUseCase";
import DeleteUserUseCase, { DeleteUserUseCaseName } from "./domain/use_cases/user/DeleteUserUseCase";
import CreateUserUseCase, { CreateUserUseCaseName } from "./domain/use_cases/user/CreateUserUseCase";
import UpdateUserUseCase, { UpdateUserUseCaseName } from "./domain/use_cases/user/UpdateUserUseCase";
import DashboardRepository, { DashboardRepositoryName } from "./domain/repositories/DashboardRepository";
import DashboardRepositoryFake from "./data/repositories/dashboard/DashboardRepositoryFake";
import GetBasicDashboardDataUseCase, { GetBasicDashboardDataUseCaseName } from "./domain/use_cases/dashboard/GetBasicDashboardDataUseCase";
import LocalizationRepositoryImpl from "./data/repositories/localization/LocalizationRepositoryImpl";
import UserRepositoryFake from "./data/repositories/user/UserRepositoryFake";
import StablishmentRepository, { StablishmentRepositoryName } from "./domain/repositories/StablishmentRepository";
import CreateStablishmentUseCase, { CreateStablishmentUseCaseName } from "./domain/use_cases/stablishment/CreateStablishmentUseCase";
import SearchStablishmentsUseCase, { SearchStablishmentsUseCaseName } from "./domain/use_cases/stablishment/SearchStablishmentsUseCase";
import GetStablishmentByIdUseCase, { GetStablishmentByIdUseCaseName } from "./domain/use_cases/stablishment/GetStablishmentByIdUseCase";
import DeleteStablishmentUseCase, { DeleteStablishmentUseCaseName } from "./domain/use_cases/stablishment/DeleteStablishmentUseCase";
import UpdateStablishmentUseCase, { UpdateStablishmentUseCaseName } from "./domain/use_cases/stablishment/UpdateStablishmentUseCase";
import StablishmentRepositoryFake from "./data/repositories/stablishment/StablishmentRepositoryFake";
import StablishmentRepositoryDev from "./data/repositories/stablishment/StablishmentRepositoryDev";
import StablishmentRepositoryImpl from "./data/repositories/stablishment/StablishmentRepositoryImpl";
import UserRepositoryDev from "./data/repositories/user/UserRepositoryDev";
import UserRepositoryImpl from "./data/repositories/user/UserRepositoryImpl";
import ShiftRepository, { ShiftRepositoryName } from "./domain/repositories/ShiftRepository";
import SearchShiftsUseCase, { SearchShiftsUseCaseName } from "./domain/use_cases/shift/SearchShiftsUseCase";
import GetShiftByIdUseCase, { GetShiftByIdUseCaseName } from "./domain/use_cases/shift/GetShiftByIdUseCase";
import DeleteShiftUseCase, { DeleteShiftUseCaseName } from "./domain/use_cases/shift/DeleteShiftUseCase";
import UpdateShiftUseCase, { UpdateShiftUseCaseName } from "./domain/use_cases/shift/UpdateShiftUseCase";
import ReasignShiftUseCase, { ReasignShiftUseCaseName } from "./domain/use_cases/shift/ReasignShiftUseCase";
import ShiftRepositoryFake from "./data/repositories/shift/ShiftRepositoryFake";
import ShiftRepositoryDev from "./data/repositories/shift/ShiftRepositoryDev";
import ShiftRepositoryImpl from "./data/repositories/shift/ShiftRepositoryImpl";
import QrRepository, { QrRepositoryName } from "./domain/repositories/QrRepository";
import CreateQrsInBatchUseCase, { CreateQrsInBatchUseCaseName } from "./domain/use_cases/qr/CreateQrsInBatchUseCase";
import SearchQrsUseCase, { SearchQrsUseCaseName } from "./domain/use_cases/qr/SearchQrsUseCase";
import DisableQrUseCase, { DisableQrUseCaseName } from "./domain/use_cases/qr/DisableQrUseCase";
import QrRepositoryFake from "./data/repositories/qr/QrRepositoryFake";
import DownloadQrBatchUseCase, { DownloadQrBatchUseCaseName } from "./domain/use_cases/qr/DownloadQrBathUseCase";
import GetSchedulesByStablishmentAndDayUseCase, { GetSchedulesByStablishmentAndDayUseCaseName } from "./domain/use_cases/stablishment/GetSchedulesByStablishmentAndDayUseCase";
import DeleteScheduleUseCase, { DeleteScheduleUseCaseName } from "./domain/use_cases/stablishment/DeleteScheduleUseCase";
import CreateShiftWithScheduleUseCase, { CreateShiftWithScheduleUseCaseName } from "./domain/use_cases/shift/CreateShiftWithScheduleUseCase";
import GetAvailableUsersUseCase, { GetAvailableUsersUseCaseName } from "./domain/use_cases/user/GetAvailableUsersUseCase";
import DashboardRepositoryDev from "./data/repositories/dashboard/DashboardRepositoryDev";
import DashboardRepositoryImpl from "./data/repositories/dashboard/DashboardRepositoryImpl";
import ReportRepository, { ReportRepositoryName } from "./domain/repositories/ReportRepository";
import ReportRepositoryFake from "./data/repositories/report/ReportRepositoryFake";
import ReportRepositoryDev from "./data/repositories/report/ReportRepositoryDev";
import GetUserReportUseCase, { GetUserReportUseCaseName } from "./domain/use_cases/report/GetUserReportUseCase";
import QrRepositoryImpl from "./data/repositories/qr/QrRepositoryImpl";
import QrRepositoryDev from "./data/repositories/qr/QrRepositoryDev";
import ReDownloadQrBatchUseCase, { ReDownloadQrBatchUseCaseName } from "./domain/use_cases/qr/ReDownloadQrBathUseCase";
import SortSchedulesUseCase, { SortSchedulesUseCaseName } from "./domain/use_cases/schedule/SortSchedulesUseCase";
import ReportRepositoryImpl from "./data/repositories/report/ReportRepositoryImpl";

enum MODE_DI { PRODUCTION, DEVELOPMENT, TEST, FAKE }

let mode = MODE_DI.DEVELOPMENT.toString();
const di = new Container();
//#region ------------------ CONSTANTS ------------------ //
if (mode === MODE_DI.FAKE.toString()) {
    di.bind<Constants>(ConstantsName).toConstantValue(ConstantsFake);
} else if (mode === MODE_DI.DEVELOPMENT.toString()) {
    di.bind<Constants>(ConstantsName).toConstantValue(ConstantsDev);
} else {
    di.bind<Constants>(ConstantsName).toConstantValue(ConstantsImpl);
}

di.bind<HostApi>(HostApiName).to(HostApi).inSingletonScope();
//#endregion ------------------ CONSTANTS ------------------ 0//

//#region ------------------ REPOSITORIES ------------------ //
if (mode === MODE_DI.FAKE.toString()) {
    di.bind<AuthRepository>(AuthRepositoryName).to(AuthRepositoryFake).inSingletonScope();
    di.bind<LocalizationRepository>(LocalizationRepositoryName).to(LocalizationRepositoryFake).inSingletonScope();
    di.bind<UserRepository>(UserRepositoryName).to(UserRepositoryFake).inSingletonScope();
    di.bind<ReportRepository>(ReportRepositoryName).to(ReportRepositoryFake).inSingletonScope();
    di.bind<StablishmentRepository>(StablishmentRepositoryName).to(StablishmentRepositoryFake).inSingletonScope();
    di.bind<ShiftRepository>(ShiftRepositoryName).to(ShiftRepositoryFake).inSingletonScope();
    di.bind<QrRepository>(QrRepositoryName).to(QrRepositoryFake).inSingletonScope();
    di.bind<DashboardRepository>(DashboardRepositoryName).to(DashboardRepositoryFake).inSingletonScope();
} else if (mode === MODE_DI.DEVELOPMENT.toString()) {
    di.bind<AuthRepository>(AuthRepositoryName).to(AuthRepositoryDev).inSingletonScope();
    di.bind<DashboardRepository>(DashboardRepositoryName).to(DashboardRepositoryDev).inSingletonScope();
    di.bind<LocalizationRepository>(LocalizationRepositoryName).to(LocalizationRepositoryDev).inSingletonScope();
    di.bind<UserRepository>(UserRepositoryName).to(UserRepositoryDev).inSingletonScope();
    di.bind<ReportRepository>(ReportRepositoryName).to(ReportRepositoryDev).inSingletonScope();
    di.bind<StablishmentRepository>(StablishmentRepositoryName).to(StablishmentRepositoryDev).inSingletonScope();
    di.bind<ShiftRepository>(ShiftRepositoryName).to(ShiftRepositoryDev).inSingletonScope();
    di.bind<QrRepository>(QrRepositoryName).to(QrRepositoryDev).inSingletonScope();
} else {
    di.bind<AuthRepository>(AuthRepositoryName).to(AuthRepositoryImpl).inSingletonScope();
    di.bind<DashboardRepository>(DashboardRepositoryName).to(DashboardRepositoryImpl).inSingletonScope();
    di.bind<LocalizationRepository>(LocalizationRepositoryName).to(LocalizationRepositoryImpl).inSingletonScope();
    di.bind<ReportRepository>(ReportRepositoryName).to(ReportRepositoryImpl).inSingletonScope();
    di.bind<UserRepository>(UserRepositoryName).to(UserRepositoryImpl).inSingletonScope();
    di.bind<StablishmentRepository>(StablishmentRepositoryName).to(StablishmentRepositoryImpl).inSingletonScope();
    di.bind<ShiftRepository>(ShiftRepositoryName).to(ShiftRepositoryImpl).inSingletonScope();
    di.bind<QrRepository>(QrRepositoryName).to(QrRepositoryImpl).inSingletonScope();
}
//#endregion ------------------ REPOSITORIES ------------------ //

//#region ------------------ PROVIDERS ------------------ //   
di.bind<LocalizationProvider>(LocalizationProviderName).toConstantValue(LocalizationProviderImpl);
di.bind<ModalsProvider>(ModalsProviderName).toConstantValue(ModalsProviderImpl);
di.bind<UserProvider>(UserProviderName).toConstantValue(UserProviderImpl);
//#endregion ------------------ PROVIDERS ------------------ //   


//#region ------------------ USE CASES ------------------//
//#region ------------------ Authentication ------------------ //
di.bind<GetCurrentUserUseCase>(GetCurrentUserUseCaseName).toDynamicValue((context) => {
    return new GetCurrentUserUseCase({
        authRepository: context.container.get<AuthRepository>(AuthRepositoryName),
        userProvider: context.container.get<UserProvider>(UserProviderName)
    });
}).inSingletonScope();
di.bind<LoginWithEmailAndPasswordUseCase>(LoginWithEmailAndPasswordUseCaseName).toDynamicValue((context) => {
    return new LoginWithEmailAndPasswordUseCase({
        authRepository: context.container.get<AuthRepository>(AuthRepositoryName),
        userProvider: context.container.get<UserProvider>(UserProviderName)
    });
}).inSingletonScope();
di.bind<LogoutUseCase>(LogoutUseCaseName).toDynamicValue((context) => {
    return new LogoutUseCase({
        authRepository: context.container.get<AuthRepository>(AuthRepositoryName),
        userProvider: context.container.get<UserProvider>(UserProviderName)
    });
}).inSingletonScope();
//#endregion ------------------ Authentication ------------------ //
//#region ------------------ Default ------------------ //
di.bind<LoadUseCase>(LoadUseCaseName).toDynamicValue((context) => {
    return new LoadUseCase({
    });
}).inSingletonScope();
//#endregion ------------------ Default ------------------ //
//#region ------------------ Localization ------------------ //
di.bind<GetAvailableLanguagesUseCase>(GetAvailableLanguagesUseCaseName).toDynamicValue((context) => {
    return new GetAvailableLanguagesUseCase({
        localizationRepository: context.container.get<LocalizationRepository>(LocalizationRepositoryName),
        localizationProvider: context.container.get<LocalizationProvider>(LocalizationProviderName)
    });
}).inSingletonScope();
di.bind<GetCurrentLanguageUseCase>(GetCurrentLanguageUseCaseName).toDynamicValue((context) => {
    return new GetCurrentLanguageUseCase({
        localizationRepository: context.container.get<LocalizationRepository>(LocalizationRepositoryName),
        localizationProvider: context.container.get<LocalizationProvider>(LocalizationProviderName)
    });
}).inSingletonScope();
di.bind<SetCurrentLanguageUseCase>(SetCurrentLanguageUseCaseName).toDynamicValue((context) => {
    return new SetCurrentLanguageUseCase({
        localizationRepository: context.container.get<LocalizationRepository>(LocalizationRepositoryName),
        localizationProvider: context.container.get<LocalizationProvider>(LocalizationProviderName)
    });
}).inSingletonScope();
//#endregion ------------------ Localization ------------------ //
//#region ------------------ Dashboard ------------------ //
di.bind<GetBasicDashboardDataUseCase>(GetBasicDashboardDataUseCaseName).toDynamicValue((context) => {
    return new GetBasicDashboardDataUseCase({
        dashboardRepository: context.container.get<DashboardRepository>(DashboardRepositoryName)
    });
}).inSingletonScope();
//#endregion ------------------ Dashboard ------------------ //
//#region ------------------ QA ------------------ //
di.bind<CreateUserUseCase>(CreateUserUseCaseName).toDynamicValue((context) => {
    return new CreateUserUseCase({
        userRepository: context.container.get<UserRepository>(UserRepositoryName)
    });
}).inSingletonScope();
di.bind<DeleteUserUseCase>(DeleteUserUseCaseName).toDynamicValue((context) => {
    return new DeleteUserUseCase({
        userRepository: context.container.get<UserRepository>(UserRepositoryName)
    });
}).inSingletonScope();
di.bind<GetUserByIdUseCase>(GetUserByIdUseCaseName).toDynamicValue((context) => {
    return new GetUserByIdUseCase({
        userRepository: context.container.get<UserRepository>(UserRepositoryName)
    });
}).inSingletonScope();
di.bind<SearchUsersUseCase>(SearchUsersUseCaseName).toDynamicValue((context) => {
    return new SearchUsersUseCase({
        userRepository: context.container.get<UserRepository>(UserRepositoryName)
    });
}).inSingletonScope();
di.bind<UpdateUserUseCase>(UpdateUserUseCaseName).toDynamicValue((context) => {
    return new UpdateUserUseCase({
        userRepository: context.container.get<UserRepository>(UserRepositoryName)
    });
}).inSingletonScope();
//#endregion ------------------ QA ------------------ //
//#region ------------------ STABLISHMENTS ------------------ //
di.bind<CreateStablishmentUseCase>(CreateStablishmentUseCaseName).toDynamicValue((context) => {
    return new CreateStablishmentUseCase({
        stablishmentRepository: context.container.get<StablishmentRepository>(StablishmentRepositoryName)
    });
}).inSingletonScope();
di.bind<DeleteStablishmentUseCase>(DeleteStablishmentUseCaseName).toDynamicValue((context) => {
    return new DeleteStablishmentUseCase({
        stablishmentRepository: context.container.get<StablishmentRepository>(StablishmentRepositoryName)
    });
}).inSingletonScope();
di.bind<GetStablishmentByIdUseCase>(GetStablishmentByIdUseCaseName).toDynamicValue((context) => {
    return new GetStablishmentByIdUseCase({
        stablishmentRepository: context.container.get<StablishmentRepository>(StablishmentRepositoryName)
    });
}).inSingletonScope();
di.bind<GetSchedulesByStablishmentAndDayUseCase>(GetSchedulesByStablishmentAndDayUseCaseName).toDynamicValue((context) => {
    return new GetSchedulesByStablishmentAndDayUseCase({
        stablishmentRepository: context.container.get<StablishmentRepository>(StablishmentRepositoryName)
    });
}).inSingletonScope();
di.bind<DeleteScheduleUseCase>(DeleteScheduleUseCaseName).toDynamicValue((context) => {
    return new DeleteScheduleUseCase({
        stablishmentRepository: context.container.get<StablishmentRepository>(StablishmentRepositoryName)
    });
}).inSingletonScope();
di.bind<SortSchedulesUseCase>(SortSchedulesUseCaseName).to(SortSchedulesUseCase).inSingletonScope();
di.bind<SearchStablishmentsUseCase>(SearchStablishmentsUseCaseName).toDynamicValue((context) => {
    return new SearchStablishmentsUseCase({
        stablishmentRepository: context.container.get<StablishmentRepository>(StablishmentRepositoryName)
    });
}).inSingletonScope();
di.bind<UpdateStablishmentUseCase>(UpdateStablishmentUseCaseName).toDynamicValue((context) => {
    return new UpdateStablishmentUseCase({
        stablishmentRepository: context.container.get<StablishmentRepository>(StablishmentRepositoryName)
    });
}).inSingletonScope();
//#endregion ------------------ STABLISHMENTS ------------------ //
//#region ------------------ SHIFTS ------------------ //
di.bind<CreateShiftWithScheduleUseCase>(CreateShiftWithScheduleUseCaseName).toDynamicValue((context) => {
    return new CreateShiftWithScheduleUseCase({
        shiftRepository: context.container.get<ShiftRepository>(ShiftRepositoryName)
    });
}).inSingletonScope();
di.bind<DeleteShiftUseCase>(DeleteShiftUseCaseName).toDynamicValue((context) => {
    return new DeleteShiftUseCase({
        shiftRepository: context.container.get<ShiftRepository>(ShiftRepositoryName)
    });
}).inSingletonScope();
di.bind<GetAvailableUsersUseCase>(GetAvailableUsersUseCaseName).toDynamicValue((context) => {
    return new GetAvailableUsersUseCase({
        userRepository: context.container.get<UserRepository>(UserRepositoryName)
    });
}).inSingletonScope();
di.bind<GetShiftByIdUseCase>(GetShiftByIdUseCaseName).toDynamicValue((context) => {
    return new GetShiftByIdUseCase({
        shiftRepository: context.container.get<ShiftRepository>(ShiftRepositoryName)
    });
}).inSingletonScope();
di.bind<SearchShiftsUseCase>(SearchShiftsUseCaseName).toDynamicValue((context) => {
    return new SearchShiftsUseCase({
        shiftRepository: context.container.get<ShiftRepository>(ShiftRepositoryName)
    });
}).inSingletonScope();
di.bind<UpdateShiftUseCase>(UpdateShiftUseCaseName).toDynamicValue((context) => {
    return new UpdateShiftUseCase({
        shiftRepository: context.container.get<ShiftRepository>(ShiftRepositoryName)
    });
}).inSingletonScope();
di.bind<ReasignShiftUseCase>(ReasignShiftUseCaseName).toDynamicValue((context) => {
    return new ReasignShiftUseCase({
        shiftRepository: context.container.get<ShiftRepository>(ShiftRepositoryName)
    });
}).inSingletonScope();
//#endregion ------------------ SHIFTS ------------------ //
//#region ------------------ QRS ------------------ //
di.bind<CreateQrsInBatchUseCase>(CreateQrsInBatchUseCaseName).toDynamicValue((context) => {
    return new CreateQrsInBatchUseCase({
        qrRepository: context.container.get<QrRepository>(QrRepositoryName)
    });
}).inSingletonScope();
di.bind<DownloadQrBatchUseCase>(DownloadQrBatchUseCaseName).toDynamicValue((context) => {
    return new DownloadQrBatchUseCase({
        qrRepository: context.container.get<QrRepository>(QrRepositoryName)
    });
}).inSingletonScope();
di.bind<ReDownloadQrBatchUseCase>(ReDownloadQrBatchUseCaseName).toDynamicValue((context) => {
    return new ReDownloadQrBatchUseCase({
        qrRepository: context.container.get<QrRepository>(QrRepositoryName)
    });
}).inSingletonScope();
di.bind<SearchQrsUseCase>(SearchQrsUseCaseName).toDynamicValue((context) => {
    return new SearchQrsUseCase({
        qrRepository: context.container.get<QrRepository>(QrRepositoryName)
    });
}).inSingletonScope();
di.bind<DisableQrUseCase>(DisableQrUseCaseName).toDynamicValue((context) => {
    return new DisableQrUseCase({
        qrRepository: context.container.get<QrRepository>(QrRepositoryName)
    });
}).inSingletonScope();
//#endregion ------------------ QRS ------------------ //

//#region ------------------ REPORTS ------------------ //
di.bind<GetUserReportUseCase>(GetUserReportUseCaseName).toDynamicValue((context) => {
    return new GetUserReportUseCase({
        reportRepository: context.container.get<ReportRepository>(ReportRepositoryName)
    });
}).inSingletonScope();
//#endregion ------------------ REPORTS ------------------ //

//#endregion ------------------ USE CASES ------------------//

export default di;